var React = require('react');

function HatChef (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M416 32a95.17 95.17 0 0 0-57.73 19.74C334.93 20.5 298 0 256 0s-78.93 20.5-102.27 51.74A95.56 95.56 0 0 0 0 128c0 41.74 64 192 64 192h60.09L112 169.25a8 8 0 0 1 7.33-8.61l16-1.28a8 8 0 0 1 8.61 7.34L156.2 320h83.14V168a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v152h84.46l12.27-153.3a8 8 0 0 1 8.61-7.34l16 1.28a8 8 0 0 1 7.33 8.61L387.91 320H448s64-150.26 64-192a96 96 0 0 0-96-96z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M64 480a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V352H64z","className":"fa-primary","key":2})]);
}

HatChef.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = HatChef;

HatChef.default = HatChef;
